// Other OptiPrime products that render inside this shell rather than the OptiSigns
// portal itself: OptiDev (/app/optidev) and OptiSound (/app/optisound). Same
// product family, sharing identity through OptiPrime IDM — just not this app.
//
// The Get Started checklist is OptiSigns-portal onboarding ("pair a screen",
// "create content"), so it has nothing to say on these pages and is HIDDEN while
// the user is in one. Hidden, not dismissed — this only skips rendering:
//   - the expanded/collapsed choice lives in localStorage (get-started-widget-store)
//   - "dismissed for good" lives on the server (company.getStarted.completed)
// so returning to any OptiSigns page brings the widget back exactly as it was.
export const OTHER_OPTIPRIME_PRODUCT_PREFIXES = ['/app/optidev', '/app/optisound'];

/**
 * Pure route-prefix check — pulled out of AppShell (scio3!2873) so it's testable
 * without mounting the shell. Same `startsWith` mechanism `isFullWidthPage` uses
 * inline in AppShell: a plain pathname prefix match, no host/store lookup.
 */
export function isOtherOptiPrimeProductPath(pathname: string): boolean {
  return OTHER_OPTIPRIME_PRODUCT_PREFIXES.some((p) => pathname.startsWith(p));
}
